module.exports = __webpack_public_path__ + "static/bottom_floral-2e3f3e53405dae4403c2cae5c63514ae.png";